module.exports = __webpack_public_path__ + "static/img/8.be1ed85d.png";